import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import RecipientPage from './pages/RecipientPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/r/:slug/:token" element={<RecipientPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
